export const ExportProcessType = {
    NOT_STARTED: 1,
    IN_PROGRESS: 2,
    COMPLETED: 3,
    ERROR: 4,
    DOWNLOADED: 5
}